export const constants = {
  passengerApi: import.meta.env.VITE_PASSENGER_API,
  appVersion: import.meta.env.VITE_APP_VERSION,
  product: import.meta.env.VITE_PRODUCT,
  isProd: import.meta.env.MODE === 'production',
  isStaging: import.meta.env.MODE === 'staging',
  isLocal: import.meta.env.MODE === 'development',
  isHotels: import.meta.env.VITE_PRODUCT === 'HOTELS',
  mode: import.meta.env.MODE,
  legacyWebappHost: import.meta.env.VITE_LEGACY_WEBAPP_HOST,
  redirectionHotel: import.meta.env.VITE_REDIRECTION_HOTEL,
  basename:
    import.meta.env.VITE_PRODUCT === 'HOTELS'
      ? import.meta.env.VITE_HOTELS_BASENAME
      : import.meta.env.VITE_ALLOCAB_BASENAME,
  googleAuthCred:
    import.meta.env.MODE === 'production'
      ? '37427854128-kj8fvuu7paggmjmfvcgrlp1pku3ppr66.apps.googleusercontent.com'
      : '109698789741-vkklu18sfj26op6nuicl0mfo6strmltv.apps.googleusercontent.com',
  facebookAuthCred: '137566230419536',
  googleAnalyticsId: import.meta.env.VITE_GOOGLE_ANALYTICS_ID,
  environment: import.meta.env.VITE_ENVIRONMENT,
  emailPro: 'pros@allocab.com',
  emailIndividual: 'serviceclient@allocab.com',
  mapBoxApiKey: 'pk.eyJ1IjoidHRpZXJjZWxpbiIsImEiOiJjbHR4ZGU4bzgwNTIxMnFvMDNnbjVsbWZmIn0.M7l482oMvZjKxnQf8dCauQ',
};
